/* eslint-disable react/prop-types */
import React from 'react';
import { Checkbox, CheckboxGroup, Col, FlexboxGrid } from 'rsuite';
import TextField from '~/components/textField/TextField';

export default function Checks({ setForm }) {
  function handleInfo(event) {
    setForm((form) => ({
      ...form,
      ler: event.indexOf('ler') !== -1,
      incluir: event.indexOf('incluir') !== -1,
      atualizar: event.indexOf('atualizar') !== -1,
      deletar: event.indexOf('deletar') !== -1,
      upload: event.indexOf('upload') !== -1,
      download: event.indexOf('download') !== -1,
      outros: event.indexOf('outros') !== -1,
    }));
  }
  return (
    <FlexboxGrid align="top" style={{ marginTop: '16px', width: '100%' }}>
      <FlexboxGrid.Item componentClass={Col} colspan={24} md={24}>
        <TextField
          margin="0"
          width="100%"
          name="info"
          accepter={CheckboxGroup}
          inline
          onChange={handleInfo}
        >
          <Checkbox value="ler">Ler</Checkbox>
          <Checkbox value="incluir">Incluir</Checkbox>
          <Checkbox value="atualizar">Atualizar</Checkbox>
          <Checkbox value="deletar">Deletar</Checkbox>
          <Checkbox value="upload">Upload</Checkbox>
          <Checkbox value="download">Download</Checkbox>
          <Checkbox value="outros">Outros</Checkbox>
        </TextField>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
}
